export const permissions = [
  { id: 'checkbox-all', label: 'ALL' },
  { id: 'checkbox-view', label: 'VIEW' },
  { id: 'checkbox-edit', label: 'EDIT' },
  { id: 'checkbox-user-management', label: 'USER_MANAGEMENT' },
];

export const PERMISSION_ORDER = ['VIEW', 'EDIT', 'USER_MANAGEMENT', 'ALL'];

export const PERMISSION_TRANSLATION_MAP: Record<string, string> = {
  VIEW: 'view-permission-label',
  EDIT: 'edit-permission-label',
  USER_MANAGEMENT: 'user-management-permission-label',
  ALL: 'all-permissions-label',
};

// Permissions that cannot be granted to AE/AM roles
export const RESTRICTED_PERMISSIONS = ['ALL', 'USER_MANAGEMENT'];

export const ROLE_MANAGEMENT_TABLE_HEADERS_MAP = {
  userRole: 'role-management-table-user-role-header',
  permissions: 'role-management-table-permissions-header',
  createdAt: 'role-management-table-created-at-header',
  createdBy: 'role-management-table-created-by-header',
  lastUpdatedAt: 'role-management-table-last-updated-at-header',
  lastUpdatedBy: 'role-management-table-last-updated-by-header',
};

export const EXCLUDED_ROLES_COLUMNS = ['createdBy', 'createdAt'];

export const ROLE_MANAGEMENT_COLUMN_KEYS = Object.fromEntries(
  Object.keys(ROLE_MANAGEMENT_TABLE_HEADERS_MAP).map((key) => [
    key.toUpperCase(),
    key,
  ])
);
